import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { AuthService } from './auth.service';
import { ConfigService } from '../core/services/config/config.service';

@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild {

    constructor(private auth: AuthService, private configService: ConfigService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        if (state.url === '/group-sales') {
            const value = JSON.parse(localStorage.getItem('userConfig'));
            const groupSalesKeyName = 'hasGroupSalesAccess';
            if (value[groupSalesKeyName] === true || this.configService.isGroupSalesOnlyRole()) {
                return this.hasAppAccess(state.url);
            } else {
                window.location.replace(window.location.href.replace('group-sales', 'dashboard'));
                return value[groupSalesKeyName];
            }
        }
        // Cross-buyer portfolio view is role-gated (RLP-4274) — mirrors the group-sales gate above.
        // Match on the path only so query params / trailing segments can't slip past the gate, and
        // tolerate a missing/corrupt userConfig (readConfigFlag) rather than throwing.
        const portfolioPath = state.url.split('?')[0].split('#')[0];
        if (portfolioPath === '/portfolio' || portfolioPath.startsWith('/portfolio/')) {
            if (this.readConfigFlag('hasPortfolioAccess')) {
                return this.hasAppAccess(state.url);
            }
            // Redirect via a UrlTree rather than string-replacing the full URL (which could
            // rewrite an unintended "portfolio" occurrence elsewhere in the href).
            return this.router.parseUrl('/dashboard');
        }
        return this.hasAppAccess(state.url);
    }

    // Reads a boolean flag from the persisted userConfig, tolerating a missing/corrupt value.
    private readConfigFlag(flagName: string): boolean {
        try {
            const value = JSON.parse(localStorage.getItem('userConfig'));
            return value?.[flagName] === true;
        } catch {
            return false;
        }
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.hasAppAccess(state.url);
    }

    private hasAppAccess(url: string): boolean {
        const isLoggedIn = this.auth.isLoggedIn();
        if (!isLoggedIn) {
            this.auth.beginLogin(url);
            return false;
        }
        return true;
    }
}
